import React from "react";

const HomePage = () => (
  <div className="h-screen">
    <section className="flex items-center justify-items-center h-full p-16 dark:bg-gray-900 dark:text-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-9xl dark:text-gray-600">
            <span className="sr-only">Error</span>404
          </h2>
          <p className="text-2xl font-semibold md:text-3xl">Ooops.</p>
          <p className="mt-4 mb-8 dark:text-gray-400">
            La pagina che stai cercando non è stata trovata.
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default HomePage;
